export const NEW_APP_ACTIONS = [
  {
    title: 'Link an existing app',
    subtitle:
      'If you already have an app in another development store, you can connect it to this account',
    button: {
      action: 'Connect app',
      onClick: 'onClickLinkApps',
    },
  },
  {
    title: 'Create an app using Swell CLI',
    subtitle:
      'The Swell command line interface provides tools for scaffolding, testing, and managing apps in a development store',
    actions: [
      {
        title: '1. Install Swell CLI',
        command: 'npm install @swell/cli -g',
      },
      {
        title: '2. Create a new app',
        command: 'swell create app',
      },
      {
        title: '3. Connect a development store',
        command: 'swell app push',
      },
    ],
  },
  {
    title: 'Documentation',
    actions: [
      {
        title: 'Quickstart',
        subtitle: 'Learn the basics of building Swell apps',
        button: {
          action: 'Get started',
          link: 'https://developers.swell.is/guides/quickstart-guide',
        },
      },
      {
        title: 'App tutorial',
        subtitle:
          'Learn how to create a product review app with a step-by-step tutorial',
        button: {
          action: 'Read the guide',
          link: 'https://github.com/swellstores/honest-reviews-app',
        },
      },
      {
        title: 'CLI reference',
        subtitle: 'Use the Swell CLI to manage stores and apps',
        button: {
          action: 'Read the docs',
          link: 'https://developers.swell.is/guides/swell-cli',
        },
      },
    ],
  },
  {
    title: 'Join the community',
    actions: [
      {
        icon: {
          type: 'social/github',
          width: '32px',
          height: '32px',
        },
        title: 'Github',
        subtitle: 'Engage with the Swell developer community',
        button: {
          action: 'Join the community',
          link: 'https://github.com/orgs/swellstores/discussions',
        },
      },
    ],
  },
];
